import React, { useState } from 'react';
import { Switch, Route, Link } from 'react-router-dom';

import { RegisterLoc } from '../../loc/register';
import { loc } from '../../lib/loc';

import RegisterFormWrapper from './RegisterFormWrapper';
import NewLegalRegisterForm from './NewLegalRegisterForm';
import ExistingLegalRegister from './ExistingLegalRegister';
import { observer } from 'mobx-react';

const LegalRegister = observer(() => {
    const [active, setActive] = useState(1);

    return (
        <RegisterFormWrapper
            icon={`${process.env.REACT_APP_PATH}public/img/bag-icon.svg`}
            backArrow={`${process.env.REACT_APP_PATH}public/img/arrow-left.svg`}
            title={loc(RegisterLoc.choose.legal.title)}
        >
            <div className="legal-form__tabs" data-tab="root">
                <div className="legal-form__wrap-nav">
                    <Link
                        className={'legal-form__nav-item' + (active === 0 ? ' active' : '')}
                        to="/register/legal/exist/"
                        onClick={() => setActive(0)}
                    >
                        {loc(RegisterLoc.existLegal)}
                    </Link>
                    <Link
                        className={'legal-form__nav-item' + (active === 1 ? ' active' : '')}
                        to="/register/legal/new/"
                        onClick={() => setActive(1)}
                    >
                        {loc(RegisterLoc.newLegal)}
                    </Link>
                </div>
                <Switch>
                    <Route exact path="/register/legal/exist" component={ExistingLegalRegister} />
                    <Route exact path="/register/legal/new" component={NewLegalRegisterForm} />
                </Switch>
            </div>
        </RegisterFormWrapper>
    );
});
export default LegalRegister;
